import axios from "axios";

/**
 *
 * @param date
 * @param requireTime
 * @returns {string}
 */
export const toLocaleString = (date, requireTime=true) => {

  let d = null;
  if (typeof date.getFullYear !== "function") {
    d = new Date(date);
  }
  const year = d.getFullYear();
  const month = d.getMonth() + 1;
  const day = d.getDate();
  const hour = d.getHours();
  const minute = d.getMinutes();
  const second = d.getSeconds();

  if (requireTime) {
    return `${year}-${paddingZero(month)}-${paddingZero(day)} ${paddingZero(hour)}:${paddingZero(minute)}:${paddingZero(second)}`;
  } else {
    return `${year}-${paddingZero(month)}-${paddingZero(day)}`;
  }
};

const paddingZero = (num) => {
  if (num < 10) {
    return `0${num}`;
  }
  return num;
};

export const getData = (url) => {
  return axios({
    url: url,
    method: "GET"
  })
};

